import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary/5 border-t border-border mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-serif font-bold text-primary">
              SMS Food Pro
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Premium quality flours crafted with precision and care. From traditional to multigrain blends, elevating every dish you create.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-smooth"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/smsfoodproindustries/"
                target="_blank"
                className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-smooth"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              {/* <a
                href="#"
                className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-smooth"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a> */}
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-foreground">SMS FOOD PRO INDUSTRIES</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                {/* <Phone className="h-4 w-4 text-primary mt-1 flex-shrink-0" /> */}
                {/* <a
                  href="tel:+919986639995"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  +91 9986639995
                </a> */}
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-4 w-4 text-primary mt-1 flex-shrink-0" />
                <a
                  href="tel:+919500446608"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  +91 95004 46608
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-4 w-4 text-primary mt-1 flex-shrink-0" />
                <a
                  href="mailto:smsfoodproindustries@gmail.com"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  smsfoodproindustries@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-primary mt-1 flex-shrink-0" />
                <span className="text-sm text-muted-foreground">
                  Block no : 1, 1st floor , Elumalai Vattam, Kandhampatty, <br /> Tamil Nadu, Salem, 636005

                </span>
              </li>
            </ul>
            <div className="pt-4 space-y-1">
              <p className="text-xs text-muted-foreground">FSSAI No.: 12420018001190</p>
              <p className="text-xs text-muted-foreground">GST NO.: 33BLWPS3985A2ZL</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-foreground">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/mission"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  Our Mission
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {currentYear} SMS Food Pro Industries. All rights reserved.
            </p>

            <p className="text-sm text-muted-foreground">
              Designed and Developed by <a href="https://netagency.in" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline transition-smooth">Net Agency</a>
            </p>

            <div className="flex space-x-6">
              <a
                href="#"
                className="text-sm text-muted-foreground hover:text-primary transition-smooth"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-sm text-muted-foreground hover:text-primary transition-smooth"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};